const Types = {
  UNRANKED: 1,
  RANKED: 2
};

export default Types;
